import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import RegistrationService from '@app/model/registration/service/RegistrationService';
import FormButton from '@app/component/form/button/FormButton';

const VerifyProfilePage = React.memo(() => {
    const {key} = useParams();
    const navigate = useNavigate();
    const [hasVerified, setHasVerified] = React.useState(false);

    const verifyMutation = useMutation({
        mutationFn: RegistrationService.verifyProfile,
        onSuccess: () => {
            setHasVerified(true)
        },
        onError: () => navigate("/sign-in")
    })

    useEffect(() => {
        if (!!key) {
            verifyMutation.mutate(key)
        }
    }, [key])

    return hasVerified? <div className="min-h-full bg-white">
        <div className="flex min-w-max content-center justify-center flex-1">
            <div className="flex h-dvh flex-1 flex-col justify-center px-6 py-12">
                <div className="mx-auto w-full max-w-sm lg:w-96">
                    <div>
                        <img
                            className="h-10 w-auto"
                            src="/assets/img/brand/logo-icon.png"
                            alt="RoomPulse"
                        />
                        <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                            Account Verification
                        </h2>

                    </div>
                    <div className="mt-10">
                        <p className="mt-2 leading-6 text-gray-500">
                            Your account has been verified successfully.
                        </p>
                        <p className="leading-6 text-gray-500">
                            Click below to sign in to your account.
                        </p>
                        <div className="mt-8">
                            <FormButton to='/sign-in' state='primary' extraClassName='flex w-full'>
                                Sign In
                            </FormButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative hidden flex-1 lg:block">
                <img
                    className="absolute inset-0 h-full w-full object-cover"
                    src="https://images.unsplash.com/photo-1587783456120-fa80c81a6c4c?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt=""
                />
            </div>
        </div>
    </div>: <div></div>
})

export default VerifyProfilePage;